/* eslint-disable jsx-a11y/control-has-associated-label */
import { EventAnnotationInputModel } from 'inputModels';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import { useAuth } from '../../../context';
import EventController from '../../../controller/EventController';
import { Container } from './styles';

type Props = {
  index: number;
  day: number;
  month: number;
  year: number;
  hour: number;
  getAnnotations: () => void;
};

export function MakingNote({ index, day, month, year, hour, getAnnotations }: Props) {
  const { colors } = useTheme();
  const { user } = useAuth();
  const [isMakingNote, setIsMakingNote] = useState(false);
  const [isEditingNote, setIsEditingNote] = useState(false);
  const [saveLetterText, setSaveLetterText] = useState('');

  const handleSaveText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length > 0) {
      setIsEditingNote(true);
    } else {
      setIsEditingNote(false);
    }
    setSaveLetterText(e.target.value);
  };

  const insertAnnotation = () => {
    const eventAnnotation: EventAnnotationInputModel = {
      annotation: saveLetterText,
      date: new Date(year, month, day, hour, 0, 0, 0),
      userId: user.id,
    };
    EventController.insertAnnotation(eventAnnotation).then(() => {
      setIsMakingNote(false);
      setIsEditingNote(false);
      setSaveLetterText('');
      getAnnotations();
    });
  };

  return (
    <Container color={(index + 1) % 2 === 0 ? colors.background : colors.background_white}>
      {isMakingNote ? (
        <div className="ContainerMakingNote">
          <textarea onChange={handleSaveText} placeholder="Escreva sua nota..." />
          <div>
            {!isEditingNote ? (
              <>
                <button
                  type="button"
                  className="cancel"
                  onClick={() => {
                    setIsMakingNote(false);
                  }}>
                  Cancelar
                </button>
              </>
            ) : (
              <button type="button" onClick={insertAnnotation}>
                Adicionar nota
              </button>
            )}
          </div>
        </div>
      ) : (
        <div className="ContainerMakingNote">
          <button
            type="button"
            onClick={() => {
              setIsMakingNote(true);
            }}
          />
        </div>
      )}
    </Container>
  );
}
